import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { Label, InputTextarea, Button } from '@teo/components';
import { axios } from '@/axios';
import { config } from '@/config';

export const UploadEmbedded = ({ setNewAsset, closeModal }) => {
  const { t } = useTranslation();
  const [embedded, setEmbedded] = useState('');

  const processIframe = (htmlString) => {
    const container = document.createElement('div');
    container.innerHTML = htmlString.trim();

    const iframe = container.querySelector('iframe');

    if (iframe) {
      if (!iframe.hasAttribute('allowfullscreen')) {
        iframe.setAttribute('allowfullscreen', '');
      }

      return container.innerHTML;
    } else {
      return htmlString;
    }
  };

  const handleUplod = async () => {
    if (embedded) {
      const updatedEl = processIframe(embedded);
      const dataVideo = await axios.post(`${config.backend}/assets`, {
        assetName: t('pages.create_edit_course.new_asset'),
        assetType: 'iframe',
        assetPath: updatedEl,
        // assetPath: embedUrl,
      });
      setNewAsset(dataVideo?.data);
      closeModal();
    }
  };

  return (
    <div className="flex flex-col">
      <div>
        <Label htmlFor="by-url">
          <p className="mt-6 text-sm font-semibold">
            {t('pages.create_edit_course.video_upload_modal.upload_embed')}
          </p>
        </Label>
        <InputTextarea
          id="description"
          placeholder=""
          onChange={(ev) => setEmbedded(ev.target.value)}
          value={embedded}
        />
      </div>
      <div className="mt-4 flex w-full">
        <Button className="ml-auto" onClick={() => handleUplod()}>
          {t('pages.create_edit_course.video_upload_modal.upload')}
        </Button>
      </div>
    </div>
  );
};
